import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// If the HTML was prerendered (see scripts/prerender.js), hydrate it so React
// reuses the server-rendered markup instead of throwing it away. Otherwise,
// render normally. Detection: either the prerender flag is present, or #root
// already has children (= came from a static HTML file, not the bare CRA shell).
const wasPrerendered =
  document.documentElement.getAttribute("data-prerendered") === "true" ||
  (container && container.childNodes && container.childNodes.length > 0);

if (wasPrerendered) {
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
